import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { readToken, removeLocalStorage } from "Utils/Helpers/Token";

const baseURL = process.env.REACT_APP_BACKEND_BASE_URL;
const instance = axios.create({
  baseURL: baseURL,
  timeout: 50000,
});
instance.interceptors.request.use(
  (request) => {
    request.headers = {
      'x-access-token': `${readToken()}`,
    }
    return request;
  },
  (error) => {
    Promise.reject(error);
  }
);
instance.interceptors.response.use(
  (response) => {
    return {
      code: response.status,
      status: true,
      data: response.data.data,
    };
  },
  (error) => {
    try {
      if (error.response.status === 401) {
        removeLocalStorage();
        window.open("/auth", '_self');
        window.location.replace("/auth");
      } else {
        const err_code = error.response.data.data.error.code || null;
        enqueueSnackbar(`[${error.response.status}] ${err_code}`, {
          variant: "error",
        });
        return {
          code: error.response.status,
          error: error.response.data.data.error.code,
          status: false,
        };
      }
    } catch {
      return {
        code: error,
        status: false,
      };
    }
  }
);
export default instance;
